import { PUT, GET } from "utils/restUtils";
import config from "config/config";

export const updateWebLog = (params, patientID, smsType, booked) => {
  return PUT(
    `${config.BASE_URL}/api/v1/web_logs/${patientID}?api_token=${params?.token}&current_office=${params?.current_office?.id}&web_type=${smsType}&is_appointment_booked=${booked}&page=1`
  );
};

export const getAllWebLogs = (
  params,
  page,
  type,
  startDate,
  endDate,
  search
) => {
  return GET(
    `${config.BASE_URL}/api/v1/web_logs?api_token=${params.token}&page=${page}&current_office=${params.current_office.id}&web_type=${type}&start_date=${startDate}&end_date=${endDate}&search=${search}`
  );
};

export const updateOneWebLog = (
  params,
  patientID,
  smsType,
  booked,
  note,
  current_office
) => {
  if (smsType !== "none" && booked !== "none" && note === "none") {
    return PUT(
      `${config.BASE_URL}/api/v1/web_logs/${patientID}?api_token=${params?.token}&current_office=${current_office}&web_type=${smsType}&is_appointment_booked=${booked}`
    );
  } else {
    return PUT(
      `${config.BASE_URL}/api/v1/web_logs/${patientID}?api_token=${params?.token}&current_office=${current_office}&web_type=${smsType}&is_appointment_booked=${booked}&note=${note}`
    );
  }
};

export const getWebHistory = (params, call_log_id, page) => {
  return GET(
    `${config.BASE_URL}/api/v1/web_logs/${call_log_id}/all_web_logs?api_token=${params?.token}&page=${page}`
  );
};

export const getOneWebLog = (params, id) => {
  return GET(
    `${config.BASE_URL}/api/v1/web_logs/${id}?api_token=${params.token}&current_office=${params.officeId}`
  );
};

export default {
  updateWebLog,
  getAllWebLogs,
  updateOneWebLog,
  getWebHistory,
};
